import md5 from 'md5';

const getUserComUserId = (id?: string | null): string =>
  process.env.REACT_APP_BUILD_TYPE === 'prod'
    ? md5(id)
    : `${md5(id)}_${process.env.REACT_APP_BUILD_TYPE}`;

export default getUserComUserId;
